export const membership_data = [
	{
		id: 1,
		membership: 'SF Basic Membership',
		perks: [ 'Unlimited Access to Home Club', 'Free Fitness Training', 'Free WiFi' ],
		price: 12.99,
		sale: function() {
			return (this.price - this.price * 0.2).toFixed(2);
		}
	},

	{
		id: 2,
		membership: 'SF Premium Membership',
		perks: [
			'Unlimited Access to Home Club',
			'Free Fitness Training',
			'Free Wifi',
			'Bring a Guest Anytime',
			'Use of Tanning',
			'50% Off Drinks',
			'Worldwide Travel Deals',
			'20% off Nike.com',
			'20% off Adidas.com',
			'20 off Underarmour.com',
			'20% off Gymshark.com'
		],
		price: 19.99,
		sale: function() {
			return (this.price - this.price * 0.2).toFixed(2);
		}
	}
];
